import { ActionMenuOption, AllowedActionMenuElements } from 'ui/actionMenu/types';
import { useTranslation } from 'modules/domains/list';
import { EXPORT_UNSUBSCRIBED_URL } from '../../../constants';

export const useExportUnsubscribedUsersLink = (): ActionMenuOption => {
  const { t } = useTranslation();
  return {
    as: AllowedActionMenuElements.Link,
    content: t('indexPage.pageActions.exportUnsubscribedUsers'),
    href: EXPORT_UNSUBSCRIBED_URL,
    id: 'export-unsubscribed-link',
    appendDivider: true,
  };
};
